import { View } from 'react-native'
import styled from 'styled-components'
import { Paragraph } from '../../../elements/typography'

const Container = styled(View)`
  position: relative;
  align-self: flex-start;
  margin: 0;
  padding: ${(props) => props.theme.spacing.sm}px;
  justify-content: center;
  align-items: center;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  border-color: ${(props) => props.theme.colors.white};
  border-radius: ${(props) => props.size / 2}px;
  border-width: ${(props) => props.size / 10}px;
  background: ${(props) => props.color || props.theme.colors.grayLighte};
`

// This wrapper is needed for the mobile app, other wise the initials are covered
// up by the Container's border
const InitialsWrapper = styled(View)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
`

const Initials = styled(Paragraph)`
  margin: 0;
  padding: 0;
  font-size: ${(props) => props.iconSize / 3}px;
  /* +3 helps keep the initials centred, even on very small screens */
  line-height: ${(props) => props.iconSize / 3 + 3}px;
`

export const UserIcon = ({ user, size = 45, style }) => (
  <Container size={size} color={user?.color} style={style}>
    <InitialsWrapper>
      <Initials iconSize={size}>{user?.nickname || '??'}</Initials>
    </InitialsWrapper>
  </Container>
)
